import { loadAndTrack } from "redux-request-loading";

import { MedicalOutcomeModel } from "@teamprevent/common/healthSurveillance/models";
import { ReviewHealthSurveillanceResultsAutoSavePayload } from "@teamprevent/common/questionnaires/actions";
import {
    SUBMIT_HEALTH_SURVEILLANCE_REVIEW,
    AUTO_SAVE_HEALTH_SURVEILLANCE_REVIEW,
    AUTO_SAVE_HEALTH_SURVEILLANCE_REVIEW_SUCCESS,
    LOAD_HEALTH_SURVEILLANCE_REVIEW
} from "@teamprevent/common/questionnaires/components/healthSurveillance/review/actionTypes";

import { AddTaskFormModel, MedicalOutcomes, TaskModels } from "../../task/model";
import { Dispatch } from "../../store";
import { actionTaskSuccess } from "../../crud/ohCase/actions";

import { healthSurveillanceReviewApi } from "./healthSurveillanceReviewApi";
import { HealthSurveillanceReviewKey } from "./components/HealthSurveillanceReviewForm";

export type SubmitHealthSurveillanceReviewResult = { success: boolean };

export const submitHealthSurveillanceReview = (ohCaseId: string, taskId: string, outcomes: MedicalOutcomeModel[], tasks: AddTaskFormModel[]) =>
    async (dispatch: Dispatch) => {
        const response = await loadAndTrack(
            dispatch,
            SUBMIT_HEALTH_SURVEILLANCE_REVIEW,
            healthSurveillanceReviewApi.submitHealthSurveillanceReview(ohCaseId, taskId, outcomes, tasks)
        );
        dispatch(actionTaskSuccess({ ohCaseId, tasks: response.tasks }));
        return response;
    };

export const saveHealthSurveillanceReview = (
    ohCaseId: string,
    taskId: string,
    outcomes: MedicalOutcomes,
    tasks: TaskModels,
    eTag: string) => {
    return async (dispatch: Dispatch) => {
        const response = await loadAndTrack(
            dispatch,
            AUTO_SAVE_HEALTH_SURVEILLANCE_REVIEW,
            healthSurveillanceReviewApi.saveHealthSurveillanceReview(ohCaseId, taskId, outcomes, tasks, eTag)
        );
        dispatch(saveHealthSurveillanceReviewSuccess({
            questionnaireKey: HealthSurveillanceReviewKey,
            eTag: response.eTag
        }));
        return { eTag: response.eTag };
    };
};

export const saveHealthSurveillanceReviewSuccess = (payload: ReviewHealthSurveillanceResultsAutoSavePayload) => {
    return {
        type: AUTO_SAVE_HEALTH_SURVEILLANCE_REVIEW_SUCCESS,
        payload
    };
};

export const loadSavedHealthSurveillanceReview = (ohCaseId: string, taskId: string) =>
    async (dispatch: Dispatch) => {
        const response = await loadAndTrack(
            dispatch,
            LOAD_HEALTH_SURVEILLANCE_REVIEW,
            healthSurveillanceReviewApi.getSavedHealthSurveillanceReview(ohCaseId, taskId)
        );
        return response;
    };

